import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { prjDeptCountAmountTyps } from '../../utils/forecastStaticData';
import ProjectDeptCountRows from './ProjectDeptCountRows';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

// "포캐스팅 등록 건수" → "포캐스팅 등록 현황"(수주 여부 무관, 2026-10-23). headerRows는
// 프로젝트/유지보수/합계 타입 그룹, 각 그룹 아래 건수/총금액/이익금 3개 하위 컬럼.
const ProjectDeptCountTable = ({ headerRows, data, tableRef }) => {
  const classes = useStyles();

  if (!headerRows || !data) {
    return null;
  }

  const colSpan = headerRows.length * prjDeptCountAmountTyps.length + 2;

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                본부
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                팀
              </TableCell>
              {headerRows.map((header) => (
                <TableCell colSpan={prjDeptCountAmountTyps.length} align="center" key={header.val}>
                  {header.name}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {headerRows.map((header) =>
                prjDeptCountAmountTyps.map((typ, index) => (
                  <TableCell align="center" key={`${header.val}_${index}`}>
                    {typ.name}
                  </TableCell>
                )),
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(data) && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={colSpan} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <ProjectDeptCountRows headerRows={headerRows} data={data} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ProjectDeptCountTable;
